import { render } from "./copyProjectDialog.vue?vue&type=template&id=da486904"
import script from "./copyProjectDialog.vue?vue&type=script&lang=js"
export * from "./copyProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__